import { baseApi } from '@ibk/shared-config';
export const permissioningApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getDomainPermissioning: builder.query({
            query: ({ fromParty, domain }) => ({
                method: 'GET',
                url: `/v1/authorization-service/party-permissions/${fromParty}/${domain}`,
            }),
        }),
    }),
});
export const { useLazyGetDomainPermissioningQuery } = permissioningApi;
